import { useEffect, useState } from "react"
import '../CSS/DashboardTemp.css'
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import { NavLink } from 'react-router-dom';
import MySideBar from "./MySideBar";
import NavBar from "./NavBar";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';


const DashboardTemp = () => {
    const [isLoader, setIsLoader] = useState(true);
    setTimeout(() => {
        setIsLoader(false);
    }, 3000);

    const courses = [
        { id: 1, img: "/python.jpeg", course_name: "SONY AI PYTHON - 2024" }
    ];


    useEffect(() => {
        if (window.location.toString().includes("/my") && !isLoader) {
            document.getElementById("dashboard-sidebar-link").classList.add("active")
        }
    }, [isLoader])


    return (
        <div>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="dashboard row dark" id="dashboard">
                    <MySideBar />
                    <div id="content">
                        <NavBar isPencil={false} />

                        <main>
                            <h1 className="head-title">Dashboard</h1>

                            <ul className="box-info">
                                <li>
                                    <div className="row">
                                        <img src="/cap.png" width="125" height="80" />
                                        {/* <a target="_blank" href="https://m.facebook.com/people/Infinity-Tech-Resources/100064283701151/" */}
                                        <NavLink to="/user/courses" className="icons-text">
                                            <span >
                                                <h3>3</h3>
                                                <p>Total Courses Enrolled</p>
                                            </span>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="row">
                                        <img src="/teacher.png" width="125" height="80" />
                                        {/* <a target="_blank" href="https://m.facebook.com/people/Infinity-Tech-Resources/100064283701151/" */}
                                        <NavLink to="/user/courses" className="icons-text">
                                            <span >
                                                <h3>1</h3>
                                                <p>Total Courses Completed</p>
                                            </span>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="row">
                                        <img src="/gift.png" width="125" height="80" />
                                        {/* <a target="_blank" href="https://m.facebook.com/people/Infinity-Tech-Resources/100064283701151/"> */}
                                        <NavLink to="/user/downloads" className="icons-text">
                                            <span >
                                                <h3>1</h3>
                                                <p>Certificates Available</p>
                                            </span>
                                        </NavLink>
                                    </div>
                                </li>
                            </ul>


                            <div className="table-data">
                        
                                <div className="order">
                                    <h2 style={{
                                        margin: '10px',
                                        color: 'rgba(186, 32, 32, 0.998)',
                                        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                                        paddingBottom: '10px',
                                        fontFamily: 'sans-serif',
                                    }}>My Courses</h2>
                                    <div className="courses-hp">
                                        <div className="grid-container">
                                            {courses.map((img, index) => (
                                                <div className="row">
                                                    <NavLink to={`/course/${img.id}`} className="col-5">
                                                        <div key={index} className="courses-card container">
                                                            <img src={img.img} alt={`course-${index}`} />
                                                            <div className="course-centered">
                                                                <ul>
                                                                    <li>View</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </NavLink>
                                                    <div className="course-desc">
                                                        <div className="skill">SKILL DEVELOPMENT PROGRAM</div>
                                                        <div className="course-name">{img.course_name}</div>
                                                        <button className="published-button"> Published</button>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                                <div className="todo" style={{ color: "black",display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Calendar />

                                </div>
                            </div>
                        </main>
                    </div>
                </div>


            )}
            <Footer />
        </div>
    )
}

export default DashboardTemp;